/**
 * A refused save, readable in a form: uc-core's message plus its detail lines. The `errors` array
 * is either field issues ({ field, message }, 400 from the ValidationPipe) or plain strings
 * (422 "Invalid deduction rules"); 409 carries only the message.
 */
import { isApiError } from '@/api'

export interface ServerProblem {
  status: number
  message: string
  details: string[]
}

/** "rule 0: to_pct must be ≥ from_pct" → "Rule 1: to % must be ≥ from %". */
function readable(line: string): string {
  return line
    .replace(/\brule (\d+):/i, (_m, n: string) => `Rule ${Number(n) + 1}:`)
    .replace(/\bfrom_pct\b/g, 'from %')
    .replace(/\bto_pct\b/g, 'to %')
    .replace(/\bbase_pct\b/g, 'base %')
    .replace(/\bdeduct_pct_per_point\b/g, 'deduct % per point')
    .replace(/\s*\(R\d+\)/g, '')
}

export function serverProblem(e: unknown): ServerProblem {
  if (!isApiError(e)) return { status: 0, message: e instanceof Error ? e.message : 'Something went wrong.', details: [] }
  if (e.kind === 'network') return { status: 0, message: 'No connection to the server.', details: [] }
  const raw = (e.body && typeof e.body === 'object' ? (e.body as Record<string, unknown>).errors : undefined) ?? e.issues
  const details = (Array.isArray(raw) ? raw : []).map((x: unknown) => {
    if (typeof x === 'string') return readable(x)
    const o = (x ?? {}) as Record<string, unknown>
    return readable(String(o.message ?? o.field ?? ''))
  })
  return { status: e.status, message: readable(e.message), details: details.filter(Boolean) }
}
